import getConfig from 'next/config';

const { apiPrefix = '' } = getConfig()?.publicRuntimeConfig ?? {};

export const BFF_API_ROUTES = {
  getVitrinsOffers: '/getVitrinsOffers/',
  account: '/account/',
  getScores: '/getScores/',
  sendAnalyticsEvent: '/sendAnalyticsEvent/',
  getRegionalCenters: '/getRegionalCenters/',
  findProlongationByCarNumber: '/findProlongationByCarNumber/',
  regToken: '/regToken/',
  carInfo: '/carInfo/',
  userCars: '/userCars/',
  getExistedOrderByCar: '/getExistedOrderByCar/',

  lastFineSearches: '/lastFineSearches/',
  addFineSearch: '/addFineSearch/',
  deleteFineSearch: '/deleteFineSearch/',
  finePhotos: '/finePhotos/',
  fines: '/fines/',

  geo: '/geo/',

  getLoanChartFilters: '/chartFilters/',
  getLoansData: '/loansData/',

  getIfUserHasEsia: '/hasEsia/',

  getOffersAndGroups: '/offersAndGroups/',
  applyOffer: '/applyOffer/',
  getStatuses: '/statuses/',
  getStatusesV2: '/statusesV2/',

  getCreditPurposes: '/creditPurposes/',
  getAutoModels: '/getAutoModels/',
  getAutoBrands: '/getAutoBrands/',

  validatePassport: '/validatePassport/',

  getFullAddressesAutocomplete: '/getFullAddressesAutocomplete/',
  getSeparateAddressesAutocomplete: '/getSeparateAddressesAutocomplete/',
  getFullNameSuggest: '/getFullNameSuggest/',
  getOrganizationSuggestions: '/getOrganizationSuggestions/',
  getUnitCodeSuggestions: '/getUnitCodeSuggestions/',
  getIssuedBySuggestions: '/getIssuedBySuggestions/',
  getLocationSettlement: '/getLocationSettlement/',
  getLocationByFiasId: '/getLocationByFiasId/',
  updateUserData: '/updateUserData/',
  getUserData: '/getUserData/',

  sendContact: '/sendContact/',
  sendCalculation: '/sendCalculation/',
  sendApplication: '/sendApplication/',
  sendReferralApplication: '/sendReferralApplication/',
  sendPreApprovalsSearchApplication: '/sendPreApprovalsSearchApplication/',
  sendApplicationV2: '/sendApplicationV2/',
  sendFirstTouch: '/sendFirstTouch/',

  getCarEnginePowers: '/getCarEnginePowers/',
  getCarManufactureYears: '/getCarManufactureYears/',
  getCarModifications: '/getCarModifications/',
  getCarInfo: '/getCarInfo/',
  restoreUserData: '/restoreUserData/',
  restoreWhiteLabelUserData: '/restoreWhiteLabelUserData/',
  getBranches: '/getBranches/',
  start: '/flow/start/',
  next: '/flow/next/',
  step: '/flow/step/',
  getUTMCookies: '/getUTMCookies/',
  initMfoDeal: '/initMfoDeal/',
  getJobPositionSuggest: '/getJobPositionSuggest/',
  getDeliverySlots: '/delivery/slots/',
  getIframeInfo: '/iframe/info',
  updateDeliveryAddress: '/delivery/address/update/',
  selectDeliverySlot: '/delivery/slot/select/',
  confirmationRequestDelivery: '/delivery/confirmation/request/',
  confirmationSubmitDelivery: '/delivery/confirmation/submit/',
  getProduct: '/feeds/product',
  getFeed: '/feed.xml',
};

export const BFF_PROXY_API: Record<keyof typeof BFF_API_ROUTES, string> = {
  getScores: `${apiPrefix}${BFF_API_ROUTES.getScores}`,
  geo: `${apiPrefix}${BFF_API_ROUTES.geo}`,
  fines: `${apiPrefix}${BFF_API_ROUTES.fines}`,
  lastFineSearches: `${apiPrefix}${BFF_API_ROUTES.lastFineSearches}`,
  addFineSearch: `${apiPrefix}${BFF_API_ROUTES.addFineSearch}`,
  deleteFineSearch: `${apiPrefix}${BFF_API_ROUTES.deleteFineSearch}`,
  finePhotos: `${apiPrefix}${BFF_API_ROUTES.finePhotos}`,
  carInfo: `${apiPrefix}${BFF_API_ROUTES.carInfo}`,
  userCars: `${apiPrefix}${BFF_API_ROUTES.userCars}`,
  regToken: `${apiPrefix}${BFF_API_ROUTES.regToken}`,
  getExistedOrderByCar: `${apiPrefix}${BFF_API_ROUTES.getExistedOrderByCar}`,
  account: `${apiPrefix}${BFF_API_ROUTES.account}`,
  getRegionalCenters: `${apiPrefix}${BFF_API_ROUTES.getRegionalCenters}`,
  sendAnalyticsEvent: `${apiPrefix}${BFF_API_ROUTES.sendAnalyticsEvent}`,
  findProlongationByCarNumber: `${apiPrefix}${BFF_API_ROUTES.findProlongationByCarNumber}`,
  getLoanChartFilters: `${apiPrefix}${BFF_API_ROUTES.getLoanChartFilters}`,
  getLoansData: `${apiPrefix}${BFF_API_ROUTES.getLoansData}`,
  getIfUserHasEsia: `${apiPrefix}${BFF_API_ROUTES.getIfUserHasEsia}`,
  getOffersAndGroups: `${apiPrefix}${BFF_API_ROUTES.getOffersAndGroups}`,
  applyOffer: `${apiPrefix}${BFF_API_ROUTES.applyOffer}`,
  getCreditPurposes: `${apiPrefix}${BFF_API_ROUTES.getCreditPurposes}`,
  getAutoModels: `${apiPrefix}${BFF_API_ROUTES.getAutoModels}`,
  getAutoBrands: `${apiPrefix}${BFF_API_ROUTES.getAutoBrands}`,
  getFullAddressesAutocomplete: `${apiPrefix}${BFF_API_ROUTES.getFullAddressesAutocomplete}`,
  getSeparateAddressesAutocomplete: `${apiPrefix}${BFF_API_ROUTES.getSeparateAddressesAutocomplete}`,
  getFullNameSuggest: `${apiPrefix}${BFF_API_ROUTES.getFullNameSuggest}`,
  getOrganizationSuggestions: `${apiPrefix}${BFF_API_ROUTES.getOrganizationSuggestions}`,
  getUnitCodeSuggestions: `${apiPrefix}${BFF_API_ROUTES.getUnitCodeSuggestions}`,
  getIssuedBySuggestions: `${apiPrefix}${BFF_API_ROUTES.getIssuedBySuggestions}`,
  validatePassport: `${apiPrefix}${BFF_API_ROUTES.validatePassport}`,
  getLocationSettlement: `${apiPrefix}${BFF_API_ROUTES.getLocationSettlement}`,
  getLocationByFiasId: `${apiPrefix}${BFF_API_ROUTES.getLocationByFiasId}`,
  updateUserData: `${apiPrefix}${BFF_API_ROUTES.updateUserData}`,
  getUserData: `${apiPrefix}${BFF_API_ROUTES.getUserData}`,
  sendContact: `${apiPrefix}${BFF_API_ROUTES.sendContact}`,
  sendCalculation: `${apiPrefix}${BFF_API_ROUTES.sendCalculation}`,
  sendApplication: `${apiPrefix}${BFF_API_ROUTES.sendApplication}`,
  sendReferralApplication: `${apiPrefix}${BFF_API_ROUTES.sendReferralApplication}`,
  sendApplicationV2: `${apiPrefix}${BFF_API_ROUTES.sendApplicationV2}`,
  sendFirstTouch: `${apiPrefix}${BFF_API_ROUTES.sendFirstTouch}`,
  sendPreApprovalsSearchApplication: `${apiPrefix}${BFF_API_ROUTES.sendPreApprovalsSearchApplication}`,
  getCarEnginePowers: `${apiPrefix}${BFF_API_ROUTES.getCarEnginePowers}`,
  getCarManufactureYears: `${apiPrefix}${BFF_API_ROUTES.getCarManufactureYears}`,
  getCarModifications: `${apiPrefix}${BFF_API_ROUTES.getCarModifications}`,
  getCarInfo: `${apiPrefix}${BFF_API_ROUTES.getCarInfo}`,
  restoreUserData: `${apiPrefix}${BFF_API_ROUTES.restoreUserData}`,
  restoreWhiteLabelUserData: `${apiPrefix}${BFF_API_ROUTES.restoreWhiteLabelUserData}`,
  getBranches: `${apiPrefix}${BFF_API_ROUTES.getBranches}`,
  start: `${apiPrefix}${BFF_API_ROUTES.start}`,
  getStatuses: `${apiPrefix}${BFF_API_ROUTES.getStatuses}`,
  getStatusesV2: `${apiPrefix}${BFF_API_ROUTES.getStatusesV2}`,
  getVitrinsOffers: `${apiPrefix}${BFF_API_ROUTES.getVitrinsOffers}`,
  getUTMCookies: `${apiPrefix}${BFF_API_ROUTES.getUTMCookies}`,
  next: `${apiPrefix}${BFF_API_ROUTES.next}`,
  step: `${apiPrefix}${BFF_API_ROUTES.step}`,
  initMfoDeal: `${apiPrefix}${BFF_API_ROUTES.initMfoDeal}`,
  getJobPositionSuggest: `${apiPrefix}${BFF_API_ROUTES.getJobPositionSuggest}`,
  getDeliverySlots: `${apiPrefix}${BFF_API_ROUTES.getDeliverySlots}`,
  getIframeInfo: `${apiPrefix}${BFF_API_ROUTES.getIframeInfo}`,
  updateDeliveryAddress: `${apiPrefix}${BFF_API_ROUTES.updateDeliveryAddress}`,
  selectDeliverySlot: `${apiPrefix}${BFF_API_ROUTES.selectDeliverySlot}`,
  confirmationRequestDelivery: `${apiPrefix}${BFF_API_ROUTES.confirmationRequestDelivery}`,
  confirmationSubmitDelivery: `${apiPrefix}${BFF_API_ROUTES.confirmationSubmitDelivery}`,
  getProduct: `${apiPrefix}${BFF_API_ROUTES.getProduct}`,
  getFeed: `${apiPrefix}${BFF_API_ROUTES.getFeed}`,
};
